export default __webpack_public_path__ + "static/media/trash.479f469f.svg";